<template>
  <b-container>
    <b-row class="pb-3">
      <b-col >
        <TextPillsList v-model="pillsItems"
                       :read-only="multiSelectReadOnly"
                       :valid.sync="pillsValid"
                       :pattern="/.*@.*/"
        ></TextPillsList>
      </b-col>
    </b-row>
    <b-row class="pt-5">
      <b-col>
        <b-checkbox v-model="multiSelectReadOnly">ReadOnly</b-checkbox>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="auto" v-for="i in pillsItems" :key="i">
        {{ i }}
      </b-col>
    </b-row>
    <b-row class="pt-5">
      <b-col cols="auto">
        <b-btn @click="snapshot">Read</b-btn>
      </b-col>
      <b-col cols="auto">
        {{copiedData}}
      </b-col>
    </b-row>
    <b-row class="pt-5">
      <b-col cols="auto">
        Pills Valid: {{pillsValid}}
      </b-col>
    </b-row>


  </b-container>
</template>

<script>
import TextPillsList from "@/components/inputs/controls/TextPillsList";
export default {
  name: "TextPillsListTest",
  components: {TextPillsList},
  methods:{
    snapshot(){
      this.copiedData = "";
      console.log("Clicked");

      this.pillsItems.forEach(i => this.copiedData += i + " ");
    }
  },
  data: () => {
    return {
      pillsItems: ['mcj.krs@gmail.com', 'mcj.krs2@gmail.com'],
      multiSelectReadOnly: true,
      copiedData:"",
      pillsValid:true
    }
  }
}
</script>
